<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    // this.$store
    //   .dispatch("getSetting", {})
    //   .then((res) => {
    //     if (res.code) {
    //       document.title = res.data.name.content || ''
    //     }
    //   })
    //   .catch((error) => { });
  },
};
</script>
